import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import requester from 'utils/requester';
import api from 'config/api';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import { getAuthorizedEndpointUrl } from 'helpers/urlhelper';
import { isEmpty } from 'lodash';

const KEY = 'PACKAGE_EXTRA';

const apiCall = async ({ pkg, isLoggedIn }) => {
  const { productIds = [] } = pkg;

  const f_productIds = productIds.join(',');

  if (isEmpty(f_productIds)) {
    return {
      includedPackages: [],
      includedChannels: [],
    };
  }

  const [includedPackages, includedChannels] = await Promise.all([
    requester({
      url: `${api.host}${getAuthorizedEndpointUrl(api.endpoints.searchCategory, isLoggedIn)}`,
      params: { f_productIds },
    }),
    requester({
      url: `${api.host}${getAuthorizedEndpointUrl(api.endpoints.searchChannelPublic, isLoggedIn)}`,
      params: { visibilityRights: 'PREVIEW', f_productIds },
    }),
  ]);

  return {
    includedPackages: includedPackages.content,
    includedChannels: includedChannels.content,
  };
};

const useLoadPackgeExtraData = (pkg = {}, options = {}) => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);

  return useQuery([KEY, pkg.id, isLoggedIn], () => apiCall({ pkg, isLoggedIn }), { ...options });
};

export default useLoadPackgeExtraData;
